import React from 'react';
import ScheduledMessagesPage from './components/ScheduledMessagesPage';

function ScheduledMessagesList() {
  return <ScheduledMessagesPage mode="user" />;
}

export default ScheduledMessagesList;
